var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-timeline",
    { attrs: { color: "primary", responsive: "" } },
    _vm._l(_vm.mapped, function(activity) {
      return _c(
        "q-timeline-entry",
        {
          key: activity.id,
          attrs: {
            title: activity.title,
            subtitle: activity.timePassed,
            icon: activity.icon,
            side: "left"
          }
        },
        [
          activity.description !== ""
            ? _c("div", [
                _vm._v("\n      " + _vm._s(activity.description) + "\n    ")
              ])
            : _vm._e()
        ]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }